// src/App.jsx
import React, { useEffect, useState, lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import { useStore } from './lib/store';
import { usePWA } from './hooks/usePWA';
import Cargando from './components/common/Cargando';
import LimiteError from './components/common/LimiteError';

// Cada pantalla se descarga solo cuando se necesita (quien abre el formulario público no baja el panel ni las gráficas)
const Login = lazy(() => import('./components/auth/Login'));
const Layout = lazy(() => import('./components/dashboard/Layout'));
const FormularioPublico = lazy(() => import('./components/public/FormularioPublico'));
const FirmaRepresentante = lazy(() => import('./components/public/FirmaRepresentante'));
const KioscoAcceso = lazy(() => import('./components/access/KioscoAcceso'));
const ConsentCookies = lazy(() => import('./components/common/ConsentCookies'));

function PrivateRoute({ children }) {
  const { session } = useStore();
  return session ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const { setSession, setUser } = useStore();
  const [loading, setLoading] = useState(true);

  // Activa el hook PWA: oculta splash, detecta instalación, etc.
  usePWA();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    // El splash nativo del index.html ya está visible — no mostrar nada extra
    return null;
  }

  return (
    <BrowserRouter>
      <LimiteError>
      <Suspense fallback={<Cargando />}>
      <Routes>
        {/* Ruta pública — formulario de inscripción (sin PWA, sin auth). Única pantalla con analítica (consentimiento previo) */}
        <Route path="/inscripcion" element={<><FormularioPublico /><ConsentCookies /></>} />

        {/* Ruta pública — el representante legal de un menor firma desde el enlace que genera el administrador */}
        <Route path="/firma-representante" element={<FirmaRepresentante />} />

        {/* Fase 10.2 — Kiosco de la puerta: SIN sesión de administrador; funciona con el código del dispositivo vinculado */}
        <Route path="/acceso" element={<KioscoAcceso />} />

        {/* Login */}
        <Route path="/login" element={<Login />} />

        {/* Panel de administración (protegido) */}
        <Route path="/*" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        } />
      </Routes>
      </Suspense>
      </LimiteError>
    </BrowserRouter>
  );
}
